/**
 * ניווט ראשי — מקור אמת יחיד ל-`Header.tsx` ול-`Footer.tsx`.
 *
 * ⚠️ עד 19.08.2026 כל קובץ הגדיר `NAV_LINKS` בנפרד — סיכון סטייה בין
 *    ההדר לפוטר. אוחד לכאן, כמו שכבר נעשה ל-`FULL_SCOPE_ITEMS`
 *    (Feedback1.md סעיף 4.4).
 *
 * ⭐ "מחשבון מ"ר" הוסר (Feedback1.md סעיף 5, 19.08.2026) — הפיצ'ר ירד
 *    לגמרי מהאתר, לא רק מהניווט.
 *
 * ⭐ **בוצע 20.08.2026 (Feedback1.md סעיפים 4.1/4.3):** "אודות" הוחלף
 *    ב"גלריה" (`/gallery`) — `GalleryPage.tsx` קיים, ו-`/about` הוא redirect
 *    ב-`main.tsx` (0.7, מגן על קישורים שכבר אונדקסו).
 */
export const NAV_LINKS: ReadonlyArray<{ to: string; label: string; end?: boolean }> = [
  { to: '/', label: 'בית', end: true },
  { to: '/catalog', label: 'קטלוג' },
  { to: '/gallery', label: 'גלריה' },
  { to: '/contact', label: 'צור קשר' },
];
